<p class="mb-2 text-center font-base text-base font-bold">
  {{ 'parameters.delivery-address' | translate }}
</p>
@if (this.displayedValue) {
  <div>
    <div class="my-4 flex items-center justify-between gap-3">
      <div class="min-w-0 flex-1 text-sm">
        <p>{{ displayedValue }}</p>
        @if (displayedCommentValue && firebaseToken) {
          <p class="italic text-neutral-600">{{ displayedCommentValue }}</p>
        }
      </div>
      <div class="shrink-0">
        <a
          class="cursor-pointer text-sm font-bold text-primary-600"
          (click)="openAddressesPanel()"
          >{{ 'parameters.edit' | translate }}</a
        >
      </div>
    </div>
  </div>
} @else {
  <div class="my-4">
    @if (!addressLoading && !!!this.addresses?.length) {
      <div
        class="mb-3.5"
        (focusin)="ensureAutocomplete()"
      >
        <app-input-text-atom
          [label]="'parameters.location-placeholder' | translate"
          [iconRight]="'icon-position'"
          [value]="displayedValue ?? ''"
          [cross]="true"
          (iconClick)="geolocalizeUser()"
          (valueChange)="valueChanged($event)"
        ></app-input-text-atom>
      </div>
    } @else {
      <div class="my-4 flex">
        <div class="p-2">
          <i class="icon icon-pin"></i>
        </div>
        <div class="w-full">
          <p class="mb-1.5 w-6/12 animate-pulse bg-neutral-100 py-1.5"></p>
          <p class="mb-1.5 w-4/12 animate-pulse bg-neutral-100 py-1.5"></p>
        </div>
      </div>
    }
  </div>
  <app-button-atom
    type="light"
    size="S"
    thickSize="S"
    [full]="true"
    icon="icon-position"
    [label]="'parameters.geolocalize-button' | translate"
    (clickEventEmitter)="geolocalizeUser()"
  ></app-button-atom>
}
@if (geolocalizeError?.length) {
  <div class="pt-2 font-base text-sm text-error-700">
    {{ geolocalizeError }}
  </div>
}
